import { useMutation } from "@apollo/client";
import { ADD_FRONTEND_EVENT } from "graphql/mutations";

export default function useFrontendEvents() {
  const [addFrontendEvent, { loading: adding }] = useMutation(ADD_FRONTEND_EVENT);

  const handleAddFrontendEvent = ({ key, eventableId, eventableType, payload = {} }) => {
    addFrontendEvent({
      variables: {
        input: {
          key,
          eventableId,
          eventableType,
          payload,
        },
      },
    });
  };

  return {
    adding,
    handleAddFrontendEvent,
  };
}
